import React from 'react'
import Helmet from 'react-helmet'
import config from '../utils/siteConfig'
import '../templates/base.scss'
import Layout from '../components/Layout/Layout'
import SEO from '../components/SEO'
import LogisticsContent from '../components/Logistics/LogisticsContent/LogisticsContent'
import LogisticsHero from '../components/Logistics/LogisticsHero/LogisticsHero'

const Logistics = ({ data }) => {
  const postNode = {
    title: `Logistics - ${config.siteTitle}`,
  }

  return (
    <Layout>
      <SEO postNode={postNode} pagePath="logistics" customTitle />
      <Helmet>
        <title>{`Logistics - ${config.siteTitle}`}</title>
      </Helmet>
      <LogisticsHero />
      <LogisticsContent />
    </Layout>
  )
}

export default Logistics
